/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export function Icon28Icon(props) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      version={"1.1"}
      viewBox={"0 0 1024 1024"}
      height={"1em"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <circle cx={"512"} cy={"512"} r={"90"} fill={"#bdbdbd"}></circle>

      <ellipse
        cx={"512"}
        cy={"256.55"}
        fill={"#fff"}
        rx={"180"}
        ry={"105"}
      ></ellipse>

      <ellipse
        cx={"256.56"}
        cy={"512"}
        fill={"#fff"}
        rx={"105"}
        ry={"180"}
      ></ellipse>

      <ellipse
        cx={"767.45"}
        cy={"512"}
        fill={"#fff"}
        rx={"105"}
        ry={"180"}
      ></ellipse>

      <ellipse
        cx={"512"}
        cy={"767.45"}
        fill={"#bdbdbd"}
        rx={"180"}
        ry={"105"}
      ></ellipse>
    </svg>
  );
}

export default Icon28Icon;
/* prettier-ignore-end */
